import { ref, Ref } from 'vue';
import { FormLabel, LABEL_FIELD_BETWEEN, LABEL_FIELD_NOT_CONTAIN, LABEL_FIRSTNAME, LABEL_LASTNAME } from './form';

const badNameChars = '`"\\/:;~!@#$%^&*()+={}[]|<>/?,';

function containsOneOf(str: string, chars: string) {
  let res = '';
  let c;
  for (let i = 0; i < chars.length; i += 1) {
    c = chars.charAt(i);
    if (str.indexOf(c) >= 0) {
      res += c;
    }
  }
  return res;
}

/**
 * Name name
 */
interface Result {
  name: Ref<string>;
  isNameInvalid: Ref<boolean>;
  nameMessage: Ref<FormLabel | null>;
  validate(type: 'b' | 'k' | ''): void;
}

const useNameValidation = (minLength: number, maxLength: number, fieldLabel: string): Result => {
  const name = ref('');
  const nameMessage: Ref<FormLabel | null> = ref(null);
  const isNameInvalid = ref(false);

  function clearFirstNameMessage() {
    nameMessage.value = null;
    isNameInvalid.value = false;
  }

  function validate(type: 'b' | 'k' | '') {
    const wasValid = !isNameInvalid.value;
    const isKeypress = type === 'k';
    const isBlur = type === 'b';
    const nameValue = name.value;

    const invalidChars = containsOneOf(nameValue, badNameChars);

    if (invalidChars.length) {
      nameMessage.value = { label: LABEL_FIELD_NOT_CONTAIN, params: [{ label: fieldLabel }, invalidChars] };
      isNameInvalid.value = true;
      return;
    }

    if (isKeypress && wasValid) {
      // wait blur before validating
      return;
    }

    if (isBlur && nameValue.length === 0) {
      clearFirstNameMessage();
      return;
    }

    if (nameValue.length < minLength) {
      isNameInvalid.value = true;
      nameMessage.value = {
        label: LABEL_FIELD_BETWEEN,
        params: [{ label: fieldLabel }, minLength, maxLength],
      };
      return;
    }

    clearFirstNameMessage();
  }

  return {
    name,
    isNameInvalid,
    nameMessage,
    validate,
  };
};

const useFirstNameValidation = (minLength: number, maxLength: number): Result => {
  return useNameValidation(minLength, maxLength, LABEL_FIRSTNAME);
};

const useLastNameValidation = (minLength: number, maxLength: number): Result => {
  return useNameValidation(minLength, maxLength, LABEL_LASTNAME);
};

export default {};

export { useFirstNameValidation, useLastNameValidation, useNameValidation };
